export default "__VITE_ASSET__DtxGVBep__"